import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { getCelebrationInviteUrl } from '@/utils/inviteUrl';

export function PersonalInvitationLink({ slug, accessToken, name }: { slug?: string | null; accessToken?: string; name: string }) {
  const [notice, setNotice] = useState('');
  const url = accessToken ? getCelebrationInviteUrl(slug, { token: accessToken }) : '';

  return <span className="inline-flex flex-col items-start gap-1">
    <Button type="button" variant="outline" size="sm" disabled={!url} aria-label={`Copy personal invitation for ${name}`}
      onClick={async () => {
        try { await navigator.clipboard.writeText(url); setNotice('Personal link copied'); }
        catch { setNotice('Unable to copy. Check clipboard permission.'); }
      }}>Copy link</Button>
    {!url && <span className="text-xs text-muted-foreground">Link unavailable</span>}
    {notice && <span role="status" className="text-xs">{notice}</span>}
  </span>;
}